import { ErpIntegration } from '@/types/erp';
import { TypedDocumentNode, gql } from '@apollo/client';

export type GetErpIntegrationByConnectionIdQueryType = {
  lager_asteria_erp: Array<Pick<ErpIntegration, 'system'>>;
};

export type GetErpIntegrationByConnectionIdVariablesType = {
  connection_id: string;
};

export const getErpIntegrationByConnectionIdQuery = gql`
	query getErpIntegrationByConnectionIdQuery($connection_id: String!) {
		lager_asteria_erp(where: {connection_id: {_eq: $connection_id}}) {
			system
		}
	}

` as TypedDocumentNode<
  GetErpIntegrationByConnectionIdQueryType,
  GetErpIntegrationByConnectionIdVariablesType
>;
